import { ALWAYS_LAST_ANSWER_TYPES } from './QuestionBoxView';

export function AnswerViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  const answerButtonTypes = ['simple-text', 'url', 'app-link'];
  return joint.shapes.html.AbstractElementView.extend({

    template: (function () {
      let descriptionDiv = '';
      if (siteTypeConfig.hasDescription) {
        descriptionDiv = '<div class="answer-description"></div>';
      }

      return [
        '<div class="html-element answer">',
        '<div class="anwser-image-and-text-container">',
        '<img>',
        '<div class="anwser-text-container">',
        '<div class="answer-label"></div>',
        descriptionDiv,
        '</div>',
        '</div>',
        '<div class="answer-handover-text">' + services.$translate.instant('parameters/quick_replies/details/handover') + '</div>',
        '<div class="answer-edit-container"><span class="glyphicon glyphicon-pencil answer-edit"></span></div>',
        '</div>'
      ].join('');
    })(),

    initialize: function () {
      joint.shapes.html.AbstractElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      const editSection = this.$box.find('.answer-edit');
      if (this.model.get('notEditable')) {
        editSection.addClass('hide');
      } else {
        editSection.on('click', this.editAnswer.bind(this));
      }
      this.updateDragAndDropable();
    },


    updateDragAndDropable: function () {
      // prevent drag-and-dropping user-input answer (which must always come last),
      // as well as answers used by inMessage email and phone boxes
      const excludedBoxes = ['html.EmailRequestForNotificationBox', 'html.PhoneRequestForNotificationBox'];
      const preventDragAndDrop = ALWAYS_LAST_ANSWER_TYPES.includes(this.model.get('answerType'))
        || excludedBoxes.includes(this.model.getAncestors()[0].get('type'));
      const pointerEvents = preventDragAndDrop ? 'none' : 'auto';
      this.model.attr({ rect: { 'pointer-events': pointerEvents } });
    },


    editAnswer: function (evt) {
      let parent = this.model.getAncestors()[0];
      let parentView = this.paper.findViewByModel(parent);

      function resultAction(result) {
        if (result.type === 'delete') {
          const {answerType} = result.data;
          this.model.remove.call(this.model);
          if (answerButtonTypes.includes(answerType)) {
            parentView.numberOfButtons--;
          }
          parentView.removeSpecialInputsId(answerType);
        }
        else if (result.type === 'edit' && result.data.answerType) {
          if (!answerButtonTypes.includes(this.model.get('answerType')) &&
            answerButtonTypes.includes(result.data.answerType)) {
            parentView.numberOfButtons++;
          }
          this.model.set('label', result.data.label);
          if (siteTypeConfig.hasDescription) {
            this.model.set('description', result.data.description);
          }
          this.model.set('answerType', result.data.answerType);
          parentView.saveSpecialInputsIds();
          this.model.set('hasHandover', result.data.hasHandover);
          this.model.set('pictureDataURL', result.data.pictureDataURL);
          this.model.set('hasVerbatimMode', result.data.hasVerbatimMode);
          this.model.set('inputListVariable', result.data.inputListVariable);
          this.model.set('templateJinjaVariable', result.data.templateJinjaVariable);
          this.model.set('selectedButtonIndexVariable', result.data.selectedButtonIndexVariable);
          this.model.set('UrlButtonUrl', result.data.UrlButtonUrl);
          this.model.set('UrlButtonUrlAndroid', result.data.UrlButtonUrlAndroid);
          this.model.set('UrlButtonUrlIos', result.data.UrlButtonUrlIos);
          this.model.set('UrlButtonName', result.data.UrlButtonName);
          callbacks.updateSerializedGraph(this.model.graph);
          this.updateDragAndDropable();
        }

        parentView.updateValidity(); // twitter messages have a special constraint

        //Reorder and resize needed for both editing and deleting
        parentView.reorderChildren();
        parentView.resizeQuestionBox();
      }
      const isMessageWithChoiceBox = parent.get('type') === 'html.MessageWithChoiceBox';
      let modalInstance = services.$uibModal.open({
        animation: true,
        template: require('./editAnswer.modal.html'),
        controller: 'editAnswerController',
        resolve: {
          companyId: () => context.companyId,
          siteId: () => context.site.id,
          siteTypeName: () => context.site.type_name,
          answer: function () {
            return {
              label: this.model.get('label'),
              description: this.model.get('description'),
              answerType: this.model.get('answerType'),
              hasHandover: this.model.get('hasHandover'),
              order: this.model.get('order'),
              pictureDataURL: this.model.get('pictureDataURL'),
              hasParentMessageWithChoice: isMessageWithChoiceBox,
              hasVerbatimMode: this.model.get('hasVerbatimMode'),
              inputListVariable: this.model.get('inputListVariable'),
              templateJinjaVariable: this.model.get('templateJinjaVariable'),
              selectedButtonIndexVariable: this.model.get('selectedButtonIndexVariable'),
              UrlButtonUrl: this.model.get('UrlButtonUrl'),
              UrlButtonUrlAndroid: this.model.get('UrlButtonUrlAndroid'),
              UrlButtonUrlIos: this.model.get('UrlButtonUrlIos'),
              UrlButtonName: this.model.get('UrlButtonName'),
            };
          }.bind(this),
          hasDescription: siteTypeConfig.hasDescription,
          hasPhoneEmailAnswerType: siteTypeConfig.hasPhoneEmailAnswerType,
          hasUrlAnswerType: siteTypeConfig.hasUrlAnswerType,
          labelMaxLength: siteTypeConfig.answerLabelMaxLength,
          chosenAnswerTypes: parentView.getChosenAnswerTypes(),
          canShowVerbatimCheckbox: context.isSatisfactionSurvey,
          numberOfButtons: parentView.numberOfButtons,
          minNumberOfButtonsAllowed: (!isMessageWithChoiceBox && siteTypeConfig.questionBox?.minAnswers),
          maxNumberOfButtonsAllowed: (!isMessageWithChoiceBox && siteTypeConfig.questionBox?.maxAnswers) || parentView.model.attributes.maxNumberOfButtonsAllowed
        }
      });
      modalInstance.result.then(resultAction.bind(this));
    },

    updateBox: function () {
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
      if (this.paper) {
        let answer_css = {};
        if (this.model.get('answerType') === 'user-input') {
          answer_css['font-style'] = 'italic';
          answer_css.color = '#F26101';
          if (!this.model.hasPort('out')) {
            this.model.addOutPort('out');
          }
          if (this.model.get('hasVerbatimMode')) {
            this.$box.find('.answer-label').text(services.$translate.instant('parameters/quick_replies/details/verbatim_user_input'));
          }
          else {
            this.$box.find('.answer-label').text(services.$translate.instant('parameters/quick_replies/details/user_input'));
          }
        }
        else if (this.model.get('answerType') === 'phone-number') {
          answer_css['font-style'] = 'italic';
          answer_css.color = '#F26101';
          this.$box.find('.answer-label').text(services.$translate.instant('parameters/quick_replies/details/phone_number'));
        }
        else if (this.model.get('answerType') === 'email') {
          answer_css['font-style'] = 'italic';
          answer_css.color = '#F26101';
          this.$box.find('.answer-label').text(services.$translate.instant('parameters/quick_replies/details/email'));
        }
        else if (this.model.get('answerType') === 'buttons-from-variable') {
          answer_css['font-style'] = 'italic';
          answer_css.color = '#F26101';
          if (!this.model.hasPort('out')) {
            this.model.addOutPort('out');
          }
          this.$box.find('.answer-label').text(services.$translate.instant('parameters/quick_replies/details/buttons_from_variable'));
        }
        else if (this.model.get('answerType') === 'next-box-by-default') {
          answer_css['font-style'] = 'normal';
          answer_css.color = '#666666';
          const suffix = this.model.get('hasVerbatimMode') ? ` (${services.$translate.instant('parameters/quick_replies/details/edit_answer/verbatim_user_input')})` : '';
          this.$box.find('.answer-label').text(services.$translate.instant('parameters/quick_replies/details/default_answer') + suffix);
        }
        else if (this.model.get('answerType') === 'url') {
          answer_css['font-style'] = 'normal';
          answer_css.color = '#666666';
          if (this.model.hasPort('out')) {
            this.model.removeOutPort('out');
          }
          const suffix = this.model.get('hasVerbatimMode') ? ` (${services.$translate.instant('parameters/quick_replies/details/edit_answer/verbatim_user_input')})` : '';
          this.$box.find('.answer-label').text(this.model.get('UrlButtonName'));
        }
        else if (this.model.get('answerType') === 'app-link') {
          answer_css['font-style'] = 'normal';
          answer_css.color = '#666666';
          if (this.model.hasPort('out')) {
            this.model.removeOutPort('out');
          }
          const suffix = this.model.get('hasVerbatimMode') ? ` (${services.$translate.instant('parameters/quick_replies/details/edit_answer/verbatim_user_input')})` : '';
          this.$box.find('.answer-label').text(this.model.get('UrlButtonName'));
        }
        else {
          answer_css['font-style'] = 'normal';
          answer_css.color = '#666666';
          if (!this.model.hasPort('out')) {
            this.model.addOutPort('out');
          }
          if (this.model.get('order')) {
            this.$box.find('.answer-label').text(this.model.get('order') + '. ' + this.model.get('label'));
          } else {
            this.$box.find('.answer-label').text(this.model.get('label'));
          }
        }
        this.$box.css(answer_css);

        if (siteTypeConfig.hasDescription) {
          this.$box.find('.answer-description').text(this.model.get('description'));
        }
        const pictureId = this.model.get('pictureId');
        const pictureDataURL = this.model.get('pictureDataURL');
        if (pictureDataURL) {
          this.$box.find('img').attr('src', pictureDataURL);
        } else if (pictureId) { // retrocompat with Charles' gouvfr scenarios
          services.MediasFactory.pictureUrlWithJWT(context.companyId, pictureId).then((urlWithJwt) => {
            this.$box.find('img').attr('src', urlWithJwt);
          });
        } else {
          this.$box.find('img').attr('src', null);
        }

        // Display or not Handover text
        const $handoverTextEl = this.$box.find('.answer-handover-text');
        if (this.model.get('hasHandover')) {
          $handoverTextEl.css('display', 'block');
        }
        else {
          $handoverTextEl.css('display', 'none');
        }
      }
    },

  });
}
